import { Breadcrumb } from 'src/common/types/api/v4/boats/search';
import formatLocationName from 'src/search/utils/formatLocationName';

const getLocationTitle = (breadcrumbs: Breadcrumb[]): string => {
  if (breadcrumbs.length === 0) return '';
  return formatLocationName(breadcrumbs[breadcrumbs.length - 1].name);
};

export default getLocationTitle;
